//@flow
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

// import DayTabs from './DayTabs';
import TrekOverviewContent from '../../components/TrekDetail/DayOverview';
import { getSelectedTrekById } from '../../redux/actions/selectedTrekActions';
import Loading from '../../components/Loading';
import Page from '../../components/Page';
import config from '../../config';
import { appendHoneyGuide } from '../../lib/utils';
import generateCanonicalUrl from '../../constants/trekTemplate';
import { getTrekPaymentDetails } from '../../redux/actions/trekPaymentReviewActions';

type Props = {
  url: string,
  numberOfDays: number,
  noOfReviews: number,
  isLoggedIn: boolean,
  trek: Object,
  id: string,
  getSelectedTrekById: () => void,
  fetchTrekReview: () => void,
  ratings: Object,
};

const appendFullStopAtTheEnd = highlights =>
  highlights.map(highlight => (!highlight.endsWith('.') ? `${highlight}.` : highlight));

class TrekOverview extends Component<Props> {
  static getTagsForSEO({ trek }) {
    if (trek) {
      const { banner_images, parent, highlights } = trek;
      const image = banner_images && banner_images.medium;
      const description =
        (highlights &&
          !isEmpty(highlights) &&
          appendFullStopAtTheEnd(highlights).join(' ')) ||
        '';

      if (parent) {
        return {
          description,
          image: `${config.RESOURCE_URL}/${image}` || '',
          canonicalUrl: generateCanonicalUrl(parent),
          noCrawl: true,
        };
      } else {
        return {
          description,
          image: `${config.RESOURCE_URL}/${image}` || '',
        };
      }
    }
  }

  render() {
    const { numberOfDays, trek, ratings, noOfReviews, pax } = this.props;
    const trekName = trek && trek.name;
    // const id = trek && trek.id;
    // const region = trek && trek.region;
    const trekNameWithDays = trekName && `${trekName} - ${numberOfDays} days`;

    return (
      <Page
        {...TrekOverview.getTagsForSEO(this.props)}
        title={appendHoneyGuide(trekNameWithDays)}
      >
        <div className="no-gutters">
          {/* <DayTabs
            active={0}
            numberOfDays={numberOfDays}
            prefix={url}
            name={trekName}
            id={id}
            region={region}
          /> */}
          {trek ? (
            <Fragment>
              <TrekOverviewContent
                trek={trek}
                ratings={ratings}
                noOfReviews={noOfReviews}
                pax={pax}
              />
            </Fragment>
          ) : (
            <Loading size="small" />
          )}
        </div>
      </Page>
    );
  }

  componentDidMount() {
    const { getSelectedTrekById, trek, match, fetchTrekReview } = this.props;
    const trekAlreadyOnStore = trek && match.params.trekId === trek.id;

    if (!trekAlreadyOnStore) getSelectedTrekById();
    // fetching trek review to know whether the flight is one-way or two-way
    // since on self guided trek see what's included check for flight availability
    // if the flight is only available the user is allowed to proceed to the review page.
    fetchTrekReview();
  }

  componentDidUpdate(prevProps) {
    const { id, getSelectedTrekById, isLoggedIn, fetchTrekReview } = this.props;
    const hrefUrl = window.location.href;

    if (hrefUrl.includes('forkedTrek')) return null;

    if (prevProps.id !== id) {
      getSelectedTrekById();
      fetchTrekReview();
    }
    if (prevProps.isLoggedIn !== isLoggedIn) getSelectedTrekById();
  }
}

const getNumberOfDays = itineraryObj => Object.keys(itineraryObj).length;

const mapStateToProps = ({
  selectedTrek,
  user,
  ratingsState,
  reviewsState,
  trekPayment,
}) => ({
  numberOfDays: selectedTrek.trek ? getNumberOfDays(selectedTrek.trek.itinerary) : 0,
  trek: selectedTrek.trek,
  isLoggedIn: Boolean(user.userId),
  ratings: ratingsState.ratings,
  noOfReviews: reviewsState.reviews.length,
  pax: trekPayment.noOfPeople,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchTrekReview: () => dispatch(getTrekPaymentDetails(ownProps.match.params.trekId)),
  getSelectedTrekById: () => dispatch(getSelectedTrekById(ownProps.match.params.trekId)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TrekOverview)
);



// WEBPACK FOOTER //
// ./src/screens/Trek/TrekOverview.js